import { get, post, qs } from './http.ts';
import type { ActivityEntry, ApiNode, VersionItem } from './types.ts';

export const versions = (
  namespaceId: string, path: string,
): Promise<{ node: ApiNode; versions: VersionItem[]; next_cursor: number | null }> =>
  get(`/history/versions${qs({ namespace_id: namespaceId, path, limit: 100 })}`);

export const activity = (
  namespaceId: string, path?: string,
): Promise<{ entries: ActivityEntry[]; next_cursor: number | null }> =>
  get(`/history/activity${qs({ namespace_id: namespaceId, path, limit: 100 })}`);

export const restoreVersion = (
  namespaceId: string, path: string, versionId: string,
): Promise<{ node: ApiNode; journal_seq: number }> =>
  post('/history/restore', { namespace_id: namespaceId, path, version_id: versionId });
